import { useStackables } from "common/stackable/hooks";

import { ConsentPreferencesDialog } from "../components/ConsentPreferencesDialog";

export const useConsentPreferencesDialog = () => {
  const { push } = useStackables();
  return {
    open: () =>
      push({
        type: "dialog",
        render: ({ onClose }) => <ConsentPreferencesDialog onClose={onClose} />,
      }),
  };
};
